import React from 'react';
import {
    CModal,
    CModalBody,
    CButton,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';

const LeaveComponentChangePopup = ({ show, onClose, onAccept, children, title, btnKeepEdit, btnAbandon }) => {
    return (
        <div className="confirm-save-popup leave-component">
            <CModal
                visible={show}
                onClose={onClose}
                color="primary"
                alignment="center"
                portal={false}
            >
                <CModalBody className="text-center confirm-save">
                    <div className="confirm-save-icon"><CIcon icon="icon-save" height={46} width={46} /></div>
                    <h2>{title}</h2>
                    <div className="confirm-save-content">
                        {children}
                    </div>
                    <div className="position-relative d-inline-block">
                        {
                            <CButton
                                className="btn-primary"
                                onClick={onClose}
                            >
                                {
                                    btnKeepEdit || "Keep Editing the Table"
                                }
                            </CButton>
                        }
                        <CButton
                            onClick={onAccept}
                            className="btn-light"
                        >
                            {btnAbandon || "Abandon My Changes & Leave"}
                        </CButton>
                    </div>
                </CModalBody>
            </CModal>
        </div>
    )
}


LeaveComponentChangePopup.propTypes = {
     onAccept: PropTypes.func,
     btnAbandon: PropTypes.any,
     children: PropTypes.node,
     btnKeepEdit: PropTypes.any,
     show: PropTypes.any,
     onClose: PropTypes.func,
     title: PropTypes.string,
};

export default LeaveComponentChangePopup
